import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import type { BlockquoteBlock } from '@/types/contentBlocks';

interface BlockquoteBlockProps {
  block: BlockquoteBlock;
  isDarkMode: boolean;
}

export const BlockquoteBlockRenderer: React.FC<BlockquoteBlockProps> = ({ block, isDarkMode }) => {
  return (
    <blockquote
      className={`my-4 pl-4 border-l-4 ${
        isDarkMode ? 'border-gray-600 text-gray-300' : 'border-gray-300 text-gray-700'
      } italic`}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkMath]}
        rehypePlugins={[
          [
            rehypeKatex,
            {
              strict: false,
              throwOnError: false,
              trust: true,
            },
          ],
        ]}
      >
        {block.content}
      </ReactMarkdown>
    </blockquote>
  );
};
